import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import debounce from 'integrations-lib/utils/debounce';
import { useFormEligible } from '../hooks/useFormEligible';
import { useFutureWebinars } from '../hooks/useFutureWebinars';
import { DropDownFooter } from './DropDownFooter';
import { buildAlertForWebinarForm, handleWebinarsFormFailureAlert } from '../../common/utils/alerts';
import { INTEGRATION_STATUS } from '../constants';
import { ErrorsType } from '../../common/constants/commonConstants';
import { errorLabels } from '../../common/utils/errorUtils';
import { filterOptions } from '../../common/utils/selectUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const WebinarSelectionForm = ({
  appName,
  appId,
  formGuid,
  onWebinarChange,
  useOnDark,
  webinarId,
  webinarSource,
  appStatus
}) => {
  const {
    isFormEligible,
    isFormEligibleLoading
  } = useFormEligible(formGuid);
  const {
    futureWebinars,
    nextCursor,
    isLoadingDropDownFooter,
    isLoading,
    error,
    search,
    loadMore
  } = useFutureWebinars(appId, webinarId);
  const isDisconnect = appStatus !== INTEGRATION_STATUS.CONNECTED;
  const onChange = ({
    target: {
      value
    }
  }) => {
    if (value) {
      onWebinarChange(value, webinarSource);
    } else {
      onWebinarChange(null, null);
    }
  };
  const onInputValueChange = debounce(newSearchValue => {
    search(newSearchValue);
  }, 1000);
  const renderWebinarSelectionForm = () => {
    if (isLoading || isFormEligibleLoading) {
      return /*#__PURE__*/_jsx(LoadingSpinner, {
        layout: "centered",
        showLabel: true
      });
    }
    if (error) {
      return handleWebinarsFormFailureAlert(error, appName);
    }
    const renderDropDownFooter = () => {
      return /*#__PURE__*/_jsx(DropDownFooter, {
        isLoadingDropDownFooter: isLoadingDropDownFooter,
        loadMore: loadMore
      });
    };
    return isDisconnect ? buildAlertForWebinarForm(errorLabels[ErrorsType.INTEGRATION_DISCONNECTED_FOR_WEBINAR_FORMS_ERROR], appName, true) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Tooltip, {
        disabled: isFormEligible,
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "videoConference.settings.webinarsForm.tooltip.head"
        }),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "videoConference.settings.webinarsForm.tooltip.body",
          options: {
            appName
          }
        }),
        children: /*#__PURE__*/_jsx(UISelect, {
          placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "videoConference.settings.webinarsForm.placeholder.label"
          }),
          options: futureWebinars,
          value: webinarId,
          onChange: onChange,
          clearable: true,
          disabled: !isFormEligible,
          buttonUse: useOnDark ? 'form-on-dark' : 'form',
          onInputValueChange: ({
            target: {
              value
            }
          }) => onInputValueChange(value),
          filterOptions: filterOptions,
          dropdownFooter: nextCursor && renderDropDownFooter()
        })
      })
    });
  };
  return renderWebinarSelectionForm();
};
export default WebinarSelectionForm;